import React, { useEffect, useContext, useState, useCallback } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { Elements } from 'react-stripe-elements'
import CheckoutForm from '../../components/CheckoutForm'

import gettheboxLogo from '../../assets/images/getthebox.png';
import gettheboxLogo2x from '../../assets/images/getthebox@2x.png';
import './Transaction.css';
import FirebaseContext from '../../firebase/context';

export default () => {
    const history = useHistory();
    const { transactionId, transactionKey } = useParams();
    const firebase = useContext(FirebaseContext);

    const [total, setTotal] = useState(0);
    const [secret, setSecret] = useState(null);
    const [redirect, setRedirect] = useState(null);
    const [completed, setCompleted] = useState(false);
    const [retry, setRetry] = useState(false);

    useEffect(() => {
        if (!transactionId) history.push('/');

        (transactionId && transactionKey) && (async () => {
            const callParams = { transactionId, paymentKey: transactionKey };
            const { clientSecret, chargedAmount, redirectTo, error, tryAgain } = await firebase.callFunction('getPaymentDataByKey', callParams);
            if (error) {
                if (!tryAgain) {
                    console.log(`Could not get payment data`)
                } else {
                    setRetry(true);
                    setTimeout(async () => {
                        const { clientSecret, chargedAmount, redirectTo, error } = await firebase.callFunction('getPaymentDataByKey', callParams);
                        if (error) {
                            console.log('Could not get payment data second time')
                        } else {
                            setTotal(chargedAmount);
                            setSecret(clientSecret);
                            setRedirect(redirectTo);
                        }

                        setRetry(false);
                    }, 10000)
                }
            } else {
                setTotal(chargedAmount);
                setSecret(clientSecret);
                setRedirect(redirectTo);
            }
        })();
    }, [history, firebase, transactionId, transactionKey]);

    const completePayment = useCallback(() => {
        setCompleted(true);

        setTimeout(() => {
            if (redirect === 'APP') {
                window.open(`getthebox://just/open`, '_self');
            } else {
                window.open(redirect, '_self');
            }
        }, 2000);
    }, [redirect]);

    return (
        <div>
            {process.env.REACT_APP_DEV === 'true' && (
                <div className="Transaction-topDev" />
            )}
            <div className="Transaction-body">
                {process.env.REACT_APP_DEV === 'true' && (
                    <div className="Transaction-dev">
                        [DEV]
                    </div>
                )}
                <img
                    alt="Getthebox"
                    src={gettheboxLogo}
                    srcSet={`${gettheboxLogo2x} 423w`}
                    sizes="213px"
                />
                {completed ? (
                    <React.Fragment>
                        <span className="Transaction-header">
                            {'Transakcja zakończona'}
                        </span>
                        <span className="Transaction-text">
                            {'Poczekaj na przekierowanie'}
                        </span>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        {transactionKey ? (
                            <React.Fragment>
                                {secret ? (
                                    <React.Fragment>
                                        <span className="Transaction-header">
                                            {'Wypełnij dane karty poniżej'}
                                        </span>
                                        <span className="Transaction-text">
                                            {`Z Twojej karty pobranie zostana kwota ${total ? total.toFixed(2) : '-'} PLN. Po transakcji zostaniesz przekierowany z powrotem.`}
                                        </span>
                                        <Elements>
                                            <CheckoutForm
                                                clientSecret={secret}
                                                transactionId={transactionId}
                                                paymentKey={transactionKey}
                                                onCompleted={completePayment}
                                            />
                                        </Elements>
                                    </React.Fragment>
                                ) : (
                                    <React.Fragment>
                                        <span className="Transaction-header">
                                            {retry ? 'Oczekiwanie na system płatności...' : 'Ładowanie danych...'}
                                        </span>
                                    </React.Fragment>
                                )}
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <span className="Transaction-header">
                                    {'Błąd: Zaktualizuj aplikację'}
                                </span>
                                <span className="Transaction-text">
                                    {'Następnie wróć do dodawania przesyłki (dane są zapisane jako szkic) i ponownie wciśnij przycisk płatności.'}
                                </span>
                            </React.Fragment>
                        )}
                    </React.Fragment>
                )}
            </div>
            <div className="Transaction-footer">
                <span className="Transaction-footerText">
                    {`Getthebox ©${(new Date()).getUTCFullYear()}`}
                </span>
            </div>
        </div>
    )
}
